import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
} from '@angular/core';
import * as React from 'react';
import {ReactBaseComponent} from '../../../../react/base/react-base.component';
import {BigFetchWithCleanPosition, FetchPositionClean} from './fetch-box.model';
import {PriceValidation} from '../../../../react/fetch/price-validation/price-validation';
import {MergedFrame} from '../../models/frame.models';
import {Suspense} from 'react';
import {EvLoadingSpinnerElement} from '../../../../react/components/ev-loading-spinner-element';

const containerElementName = 'reactFetchBoxConfirmPrice';

@Component({
  selector: 'fetch-box-confirm-price',
  template: `<div #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class FetchBoxConfirmPriceComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() position: FetchPositionClean;
  @Input() fetch: BigFetchWithCleanPosition;
  @Input() frame: MergedFrame;
  @Output() reloadFetches: EventEmitter<void> = new EventEmitter<void>();

  constructor(private ngZone: NgZone) {
    super();
  }

  reload(): void {
    this.ngZone.run(() => {
      this.reloadFetches.emit();
    });
  }

  protected override renderComponent() {
    if (this.fetch.price_validated) {
      return <i className="fa fa-check text-storz-green"/>;
    }

    return <Suspense fallback={<EvLoadingSpinnerElement/>}>
      <PriceValidation position={this.position}
                       fetch={this.fetch}
                       frame={this.frame}
                       reload={() => this.reload()}/>
    </Suspense>;
  }
}
